import { Component, Input, OnInit } from '@angular/core';
import { STRESS_PAGE, StressData } from '../common';
import {
	SelectListCustom,
	SelectListNext,
	SelectListOption,
} from '@components';
import {
	LanguageService,
	MainKey,
	MAIN_KEY_PREFIX,
	StorageService,
	TempKey,
} from '@services/public';
import { ReplaySubject, Subscription } from 'rxjs';
import { ExposedPromise } from 'jakapa-utilities-lite';

const PAGE_PATH: string = 'skillBuilders.stress.pages.look';

@Component({
	selector: 'app-member-skill-builder-stress-look',
	templateUrl: './look.component.html',
	styleUrls: ['./look.component.scss'],
})
export class MemberSkillBuilderStressLookComponent implements OnInit {
	@Input() data: StressData;
	options: ReplaySubject<Array<SelectListOption>> = new ReplaySubject<
		Array<SelectListOption>
	>(1);
	defaultOptions: Array<SelectListOption> = [];
	customOptions: Array<SelectListOption> = [];
	custom: SelectListCustom = {
		add: this.addCustom.bind(this),
		delete: this.deleteCustom.bind(this),
	};
	next: SelectListNext = {
		onClick: this.nextOnClick.bind(this),
	};
	max: number = 2;
	defaultLoaded: ExposedPromise<void> = new ExposedPromise<void>();
	private _subscriptions: Subscription = new Subscription();

	// Page langauge.
	page: { [key: string]: string } = {
		title: '',
		subTitle: '',
	};

	constructor(
		private _languageSvc: LanguageService,
		private _storageSvc: StorageService,
	) {}

	ngOnInit(): void {
		// Get page language.
		this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] !== 'object' || value[PAGE_PATH] === null)
				return;
			this.page = value[PAGE_PATH];
			for (const key in this.page)
				this._languageSvc
					.template(this.page[key])
					.then((value) => (this.page[key] = value));
		});

		// Get options list.
		const path: string = 'skillBuilders.stress.look';
		this._languageSvc.get([path]).then((value) => {
			if (typeof value[path] === 'object' && value[path] !== null)
				this.defaultOptions = Object.values(value[path]);
			this.defaultLoaded.resolve();
		});
		this._subscriptions.add(
			this._storageSvc.updates.subscribe((update) => {
				if (update.key === MAIN_KEY_PREFIX + MainKey.ALL) {
					this.customOptions = [];
					if (Array.isArray(update.value[MainKey.STRESS_LOOK])) {
						for (const option of update.value[MainKey.STRESS_LOOK]) {
							if (typeof option !== 'string') continue;
							this.customOptions.push({ display: option, custom: true });
						}
					}
					this._mergeAndSelectOptions();
				}
				if (update.key === MAIN_KEY_PREFIX + MainKey.CLEAR) {
					this.customOptions = [];
					this._mergeAndSelectOptions();
				}
				if (update.key === MAIN_KEY_PREFIX + MainKey.STRESS_LOOK) {
					this.customOptions = [];
					if (Array.isArray(update.value)) {
						for (const option of update.value) {
							if (typeof option !== 'string') continue;
							this.customOptions.push({ display: option, custom: true });
						}
					}
					this._mergeAndSelectOptions();
				}
			}),
		);
		let options: Array<string> = this._storageSvc.getMainStorage(
			MainKey.STRESS_LOOK,
		);
		if (Array.isArray(options)) {
			for (const option of options) {
				if (typeof option !== 'string') continue;
				this.customOptions.push({ display: option, custom: true });
			}
		}

		this._mergeAndSelectOptions();
	}

	private async _mergeAndSelectOptions(): Promise<void> {
		await this.defaultLoaded;
		this.options.next(
			[...this.customOptions, ...this.defaultOptions].map(
				(value: SelectListOption) => {
					if (this.data?.look?.includes(value.display))
						return { ...value, selected: true };
					return value;
				},
			),
		);
		this._updateMaxOptions();
	}

	private _updateMaxOptions(): void {
		this.max =
			(this.customOptions.length || 0) + (this.defaultOptions.length || 0);
	}

	addCustom(customOption: string): void {
		if (
			this.customOptions.findIndex(
				(option) => option.display === customOption,
			) !== -1
		)
			return;
		if (
			this.defaultOptions.findIndex(
				(option) => option.display === customOption,
			) !== -1
		)
			return;
		this.customOptions.push({ display: customOption, custom: true });
		this._storageSvc.setMainStorage(
			MainKey.STRESS_LOOK,
			this.customOptions.map((option) => option.display),
		);
	}

	deleteCustom(option: SelectListOption): void {
		this.customOptions = this.customOptions.filter(
			(customOption) => customOption.display !== option.display,
		);
		if (this.customOptions.length === 0)
			this._storageSvc.setMainStorage(MainKey.STRESS_LOOK, null);
		else
			this._storageSvc.setMainStorage(
				MainKey.STRESS_LOOK,
				this.customOptions.map((option) => option.display),
			);
	}

	nextOnClick(options: Array<SelectListOption>): void {
		this._storageSvc.setTempStorage(TempKey.STRESS, {
			...this.data,
			page: STRESS_PAGE.BRAIN,
			look: options.map((option) => option.display),
		});
	}
}
